export default __webpack_public_path__ + "static/media/leed_registro_v.9ca30b55.png";